import Backbone from 'backbone';

app.LoginView = Backbone.View.extend({
  _getParameterByName(name) {
    const url = window.location.href;

    name = name.replace(/\[/g, '\\[').replace(/\]/g, '\\]');
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  render() {
    const requestedPath = this._getParameterByName('url') || '/';
    const returnTo = `${requestedPath}${window.location.hash}`;
    const searchParams = new URLSearchParams({ returnTo });
    window.location.replace(`/v2/login?${searchParams.toString()}`);
    return this;
  },
});
